import { Col, Row } from "react-bootstrap";

export default function CardNovilla({ animal }) {
    return (
        <>
            <Row className="mb-3">
                <Col md={4}><strong>Identificador:</strong> {animal.identifier}</Col>
                <Col md={4}><strong>Raza:</strong> {animal.breed}</Col>
                <Col md={4}><strong>Fecha de nacimiento:</strong> {animal.birthDate?.slice(0,10)}</Col>
            </Row>
            <Row className="mb-3">
                <Col md={4}><strong>Situación reproductiva:</strong> {animal.reproductiveStatus || '—'}</Col>
                <Col md={4}><strong>Situación productiva:</strong> {animal.productiveStatus || '—'}</Col>
                <Col md={4}><strong>Peso:</strong> {animal.weight ? `${animal.weight} kg` : '—'}</Col>
            </Row>
            <Row className="mb-3">
                <Col md={4}><strong>Estado:</strong> {animal.status || '—'}</Col>
            </Row>
        </>
    )
}
